<template>
  <ValidationProvider
    :vid="vid"
    :name="$attrs.name"
    :rules="rules"
    v-slot="{ valid, errors }"
  >
    <b-form-group v-bind="$attrs">
      <b-form-datepicker
        class="pl-2"
        v-model="innerValue"
        v-bind="$attrs"
        :state="errors[0] ? false : valid ? true : null"
        :min="min"
        :max="max"
        locale="id"
        style="min-width:100%"
      ></b-form-datepicker>

      <b-form-invalid-feedback id="inputLiveFeedback">{{
        errors[0]
      }}</b-form-invalid-feedback>
    </b-form-group>
  </ValidationProvider>
</template>

<script>
export default {
  props: {
    min: {
      type: Date,
    },
    max: {
      type: Date,
    },
    vid: {
      type: String,
    },
    rules: {
      type: [Object, String],
      default: "",
    },
    value: {
      type: null,
    },
  },
  data: () => ({
    innerValue: "",
  }),
  watch: {
    innerValue(newVal) {
      this.$emit("input", newVal)
    },
    value(newVal) {
      this.innerValue = newVal
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value
    }
  },
}
</script>
